Vue.component('first-login-modal', {

  data() {
    return {
      steps: [
        'Just Registered',
        'Invite Colleagues',
        'Add Competitors',
        'Complete Set Up'
      ],
      currentStep: 1,
      hasInvitedColleagues: false,
      hasAddedCompetitor: false
    }
  },

  computed: {

    currentTitle() {
      return 'Invite Colleagues'
    }

  },

  methods: {
    stepStatus(num) {

      if (num < this.currentStep || this.currentStep == 6) {
        return 'completed'
      }

      if (num == this.currentStep) {
        return 'active'
      }

      return 'inactive'

    },
    nextStep() {
      this.currentStep += 1
    },
    closeModal() {
      window.history.pushState("", "GuestFlip", "/home");
      $(this.$refs.modal).modal('hide')
    },
    addedCompetitor() {
      this.hasAddedCompetitor = true

      this.$notify({
        group: 'reviews',
        title: 'Success!',
        text: 'Your competitor has been added succesfully.',
        position: 'bottom right'
      })

      this.nextStep()
    },
    processInvited(status) {
      if (status == 'success') {

        analytics.track("Invited Colleagues", {
          from_page: 'onboarding'
        })

        return this.invitedColleagues()
      }

      this.nextStep()
    },
    invitedColleagues() {
      this.hasInvitedColleagues = true

      this.$notify({
        group: 'reviews',
        title: 'Success!',
        text: 'Your colleague(s) have been invited!',
        position: 'bottom right'
      })

      this.nextStep()
    }
  },

  mounted() {

    console.log("Hi there")

    $(this.$refs.modal).modal()

    this.$eventHub.$on('multipleInvitationsAction', (status) => this.processInvited(status))

    this.$eventHub.$on('updateCompetitors', this.addedCompetitor)

  }

})